import React from 'react';
import { TableComponent } from '../../../components/TableComponent/TableComponent';
import {
  dataRows,
  dataSorting,
  headerColumn
} from '../../../utils/tablesData/NotificationsData';
import { DefaultContentT } from '../../../utils/tablesData/tablesType';

export const ListNotifications = () => {
  const defaultContent: DefaultContentT = {
    title: 'Notifications',
    tableName: 'Notifications',
    tableAPI: '/notifications/',
    sortingBySite: false,
    dataRows: dataRows,
    dataSorting: dataSorting,
    tableColumnExtensions: headerColumn,
  };

  return (
    <>
      <TableComponent data={defaultContent} />
    </>
  );
};
